<script setup>
import {computed, ref, watch} from 'vue'
import {useCategoriesStore} from '@/stores/categories'
import {useViewStore} from '@/stores/view'

const props = defineProps({
    column: Object,
    item: Object,
    viewId: String
})

// Dynamic View Store & Pinia Stores
const viewStore = useViewStore(props.viewId)
const categoriesStore = useCategoriesStore()

const count = ref(0)

const tableName = computed(() => viewStore.tableName)

// Using a standard watcher to fetch async data cleanly
watch([tableName, () => props.column.columnName, () => props.item.id], async () => {
    if (!tableName.value || !props.column.columnName) return

    const o = await categoriesStore.getTableColumnData({
        tableName: tableName.value,
        columnName: props.column.columnName
    })

    if (o) {
        count.value = o.filter(obj => obj.itemId === props.item.id).length
    } else {
        count.value = 0
    }
}, {immediate: true})
</script>

<template>
    <span v-if="count" :title="'Assigned to ' + count + ' item' + ( count > 1 ? 's' : '' ) + '.'"
          class="badge bg-secondary">{{ count }}</span>
</template>